import React from 'react';
import { getTenantConfig } from '../../config/tenantConfig';

const zebuRegInfo = [
  { label: 'SEBI Registration No', value: 'INZ000174634' },
  { label: 'NSE', value: '13179' },
  { label: 'BSE', value: '6550' },
  { label: 'MCX', value: '55730' },
  { label: 'CDSL', value: '12080400' },
  { label: 'AMFI ARN', value: '113118' },
  { label: 'Research Analyst', value: 'INH200006044' },
  { label: 'APMI / APRN Code', value: 'APRN00910' },
  { label: 'Investment Advisor SEBI Reg No', value: 'INA000017815' },
];

const PublicFooter: React.FC = () => {
  const tenant = getTenantConfig();
  const isZebu = tenant.id === 'zebu';

  return (
    <footer className="bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 py-10">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {isZebu ? (
          <>
            <div className="flex items-center gap-2 mb-4">
              <img src="/zebu-logo.svg" alt="Zebu" className="h-6 w-auto" />
            </div>
            <p className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
              Zebu Share and Wealth Managements Pvt. Ltd.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-1 mb-4">
              {zebuRegInfo.map(({ label, value }) => (
                <p key={label} className="text-xs text-gray-500 dark:text-gray-500">
                  <span className="text-gray-400 dark:text-gray-600">{label}:</span> {value}
                </p>
              ))}
            </div>
            <div className="flex items-center gap-4 mb-4">
              <span className="text-xs text-gray-400 dark:text-gray-600">Member of:</span>
              <a href="https://www.nseindia.com" target="_blank" rel="noopener noreferrer" className="text-xs font-medium text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 transition-colors">NSE</a>
              <span className="text-gray-300 dark:text-gray-700">|</span>
              <a href="https://www.bseindia.com" target="_blank" rel="noopener noreferrer" className="text-xs font-medium text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 transition-colors">BSE</a>
              <span className="text-gray-300 dark:text-gray-700">|</span>
              <a href="https://www.mcxindia.com" target="_blank" rel="noopener noreferrer" className="text-xs font-medium text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 transition-colors">MCX</a>
            </div>
            <p className="text-xs text-gray-500 dark:text-gray-500 max-w-2xl leading-relaxed">
              Trading in securities market is subject to market risks. Read all related documents
              carefully before investing. Past performance of strategies is not indicative of future
              results. Algorithmic trading involves risk of loss and is not suitable for all investors.
            </p>
            <div className="mt-4 text-xs text-gray-400 dark:text-gray-600">
              &copy; {new Date().getFullYear()} Zebu Share and Wealth Managements Pvt. Ltd. All rights reserved.
            </div>
          </>
        ) : (
          <>
            <p className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
              Quantleap Analytics LLP
            </p>
            <p className="text-xs text-gray-500 dark:text-gray-500 max-w-2xl leading-relaxed">
              Trading in securities market is subject to market risks. Read all related documents
              carefully before investing. Past performance of strategies is not indicative of future
              results. Algorithmic trading involves risk of loss and is not suitable for all investors.
            </p>
            <div className="mt-4 text-xs text-gray-400 dark:text-gray-600">
              &copy; {new Date().getFullYear()} Quantleap Analytics. All rights reserved.
            </div>
          </>
        )}
      </div>
    </footer>
  );
};

export default PublicFooter;